import axios from 'axios';

// SEC-04: the front performs NO token/secret handling whatsoever.
// All requests go to RELATIVE paths (same-origin) and are proxied by nginx to the
// HIA API (back-tenant). Any auth/token enrichment is done SERVER-SIDE (nginx BFF /
// back-tenant), never in the browser — no secret, no token, nothing in sessionStorage.
export const clientOAuth = () => ({
    get: (url, options = {}) => axios.get(url, options),
    post: (url, data, options = {}) => axios.post(url, data, options),
    put: (url, data, options = {}) => axios.put(url, data, options),
    delete: (url, options = {}) => axios.delete(url, options),
});
